
import '../Css/styles2.css'
import '../Css/bootstrap.css'


import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';


function Navbar3() {
  let location = useLocation();

  const [isNavbarOpen, setIsNavbarOpen] = useState(false);

  // Function to toggle the navbar
  const toggleNavbar = () => {
    setIsNavbarOpen(!isNavbarOpen);
  };

  // Function to close the navbar when a link is clicked
  const closeNavbar = () => {
    setIsNavbarOpen(false);
  };
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

  return (
    <div className="container-fluid navbar-main">
      <div className="container">
        <nav className={`navbar navbar-dark navbar-expand-lg py-0 ${isNavbarOpen ? 'fixed-top' : ''}`}>
          <a className="navbar-brand">
            <Link to="/">
              <img src="/UPSYS.jpg" className="navbar-img" alt="Logo" />
            </Link>
          </a>
          <button
            type="button"
            className="navbar-toggler me-0"
            onClick={toggleNavbar}
          >
            <span className="navbar-toggler-icon" />
          </button>
          <div
            className={`collapse navbar-collapse bg-transparent ${isNavbarOpen ? 'show' : ''
              }`}
            id="navbarCollapse"
          >
            <div className="navbar-nav ms-auto mx-xl-auto p-0">
              <Link to="/" onClick={closeNavbar}>
                <a href="#" className={`${location.pathname === "/" ? "nav-item nav-link active" : "nav-item nav-link"}`}>
                  Home
                </a>

              </Link>
              <div className="nav-item dropdown">
                <Link to="/services" onClick={closeNavbar}>
                  <a href="/services" className={`${location.pathname === "/services" ? "nav-item nav-link active" : "nav-item nav-link"}`}>
                    Services
                  </a>
                </Link>
              </div>


              <Link to='/careers'>
                <a href="" className={`${location.pathname === "/careers" ? "nav-item nav-link active" : "nav-item nav-link"}`} onClick={closeNavbar}>
                  Careers
                </a>
              </Link>



              <div className="nav-item dropdown">
                <Link to='/portfolio'>
                  <a href="" className={`${location.pathname === "/portfolio" ? "nav-item nav-link active" : "nav-item nav-link"}`} onClick={closeNavbar}>
                    PortFolio
                  </a>
                </Link>
              </div>

              <div className="nav-item dropdown">
                <Link to='/company'>
                  <a href="" className={`${location.pathname === "/company" ? "nav-item nav-link active" : "nav-item nav-link"}`} onClick={closeNavbar}>
                    Company
                  </a></Link>


                {/* <a href="#" className="nav-item nav-link" onClick={closeNavbar}>
              Company
            </a> */}

                {/* <div className="dropdown-menu rounded">
                <a href="#" className="dropdown-item">
                  About Us
                </a>
                <a href="#" className="dropdown-item">
                  Life At UPSYS
                </a> */}
                {/* </div> */}
              </div>

              <Link to="/contact" onClick={closeNavbar}>
                <a className={`${location.pathname === "/contact" ? "nav-item nav-link active" : "nav-item nav-link"}`}>Contact Us</a>
              </Link>
            </div>
          </div>
          <div className="d-none d-xl-flex flex-shirink-0">
            <div id="phone-tada" className="d-flex align-items-center justify-content-center me-4">
              <a href='' className="position-relative tada infinite">
                <i className="fa fa-phone-alt text-white fa-2x fa-flip-horizontal" />
                <div className="position-absolute" style={{ top: '-7px', left: '20px' }}>
                  <span><i className="fa fa-comment-dots text-secondary" /></span>
                </div>
              </a>
            </div>
            <div className="d-flex flex-column pe-4">
              <span className="text-white-50">Have any queries?</span>
              <a href='tel:+918223065170' className='text-secondary'>Contact: +91 8223065170</a>
            </div>
            <div className="d-flex align-items-center justify-content-center ms-4 search-icon-container">
              <a href="#"><i className="bi bi-search text-white fa-2x search-icon" /></a>
            </div>
          </div>
        </nav>
      </div>
    </div>
  );
}


export default Navbar3;

